import * as React from 'react';
import * as PropTypes from 'prop-types';
import LoaderComponent from '../components/common/loader.component';
import { ApplicationMain } from 'src/styles/common';
import { SurveyReportWrapper } from 'src/styles/surveyreport';
import { getCurrentUrl } from 'src/effects/utils/common';



export default class SurveyReportsContainer extends React.Component<any, any> {
    static contextTypes = {
        router: PropTypes.object
    }

    state = {
        reportIframeSrc: ''
    }

    constructor(props: any) {
        super(props);
    }

    componentDidMount() {
        getCurrentUrl().then((currUrl: any) => {
            const splitUrl = currUrl.split("/");
            const reportId = parseInt(splitUrl[splitUrl.length - 1], 10);
            this.setState({
                reportIframeSrc: this.getReportIframeSrc(reportId)
            });
        });
    }

    getReportIframeSrc(reportId: any) {
        let reportIframeSrc = "";

        switch (reportId) {
            case 1:
                {
                    reportIframeSrc = "https://public.tableau.com/views/GeneralInformation2016-2017FINALV5/GeneralInformation?:embed=y&:display_count=yes&publish=yes&:toolbar=no&:origin=viz_share_link";
                }
                break;
            case 2:
                {
                    reportIframeSrc = 'https://public.tableau.com/views/IYCF2013-2016final_0/IYCF?:embed=y&:display_count=yes&:toolbar=no&:origin=viz_share_link';
                }
                break;
            case 3:
                {
                    reportIframeSrc = 'https://public.tableau.com/shared/9NBN3ND5H?:toolbar=no&:display_count=no&:origin=viz_share_link';
                }
                break;
            case 4:
                {
                    reportIframeSrc = 'https://public.tableau.com/shared/MQ92BZBK4?:toolbar=no&:display_count=no&:origin=viz_share_link';
                }
                break;
            case 5:
                {
                    reportIframeSrc = 'https://public.tableau.com/views/Salt2013-2016final/SaltIodization?:embed=y&:display_count=yes&:toolbar=no&:origin=viz_share_link';
                }
                break;
            case 6:
                {
                    reportIframeSrc = 'https://public.tableau.com/views/SAM2013-2016/SAM?:embed=y&:display_count=yes&:toolbar=no&:origin=viz_share_link';
                }
                break;
            case 7:
                {
                    reportIframeSrc = 'https://public.tableau.com/views/Schoolageadolwomen/Schoolageadolandwomen?:embed=y&:display_count=yes&publish=yes&:toolbar=no&:origin=viz_share_link';
                }
                break;
            case 8:
                {
                    reportIframeSrc = 'https://public.tableau.com/shared/4TFNM7993?:toolbar=no&:display_count=no&:origin=viz_share_link';
                }
                break;
            case 9:
                {
                    
                    reportIframeSrc ='https://app.powerbi.com/view?r=eyJrIjoiZDhhMjlkZTEtMThlYi00MWU3LWFjYjItY2JmOTQzY2RmNjU1IiwidCI6Ijc3NDEwMTk1LTE0ZTEtNGZiOC05MDRiLWFiMTg5MjAyMzY2NyIsImMiOjh9'
                   
                }
                break;
                case 10:
                    {
                        
                        reportIframeSrc ='https://prasad.jagtap@e-zest.in:Vaibhav@1@app.powerbi.com/groups/7c8060f6-8f13-4eae-ade9-7dd9a895f0b0/reports/3a544a84-1582-4266-899e-5f6c54b86705?ctid=77410195-14e1-4fb8-904b-ab1892023667'
                       
                    }
                    break;
                    case 11:
                {
                    
                    reportIframeSrc ='https://app.powerbi.com/groups/7c8060f6-8f13-4eae-ade9-7dd9a895f0b0/reports/413999d1-62d3-4276-8166-c8c34d2c13e6?ctid=77410195-14e1-4fb8-904b-ab1892023667'
                   
                }
                break;
                case 12:
                {
                    
                    reportIframeSrc ='https://app.powerbi.com/groups/7c8060f6-8f13-4eae-ade9-7dd9a895f0b0/reports/e322e254-a80d-42fd-ab0c-3a1e9e69fdbc?ctid=77410195-14e1-4fb8-904b-ab1892023667'
                   
                }
                break;
            default:
                {
                    reportIframeSrc = '';
                }
                break;
        }

        return reportIframeSrc;
    }

    render() {
        return (
            <>
                <ApplicationMain>
                    <LoaderComponent sending={this.props.show} />

                    <SurveyReportWrapper>
                        <div className="pageContainer surveyReportScreen">
                            {
                                this.state.reportIframeSrc ?
                                    <>
                                        {
                                            <iframe src={this.state.reportIframeSrc} height="900" width="100%" className="iframeSurveyReport" />
                                        }

                                        <div>
                                            <div className='tableauPlaceholder' id='viz1558628813842' style={{ position: 'relative' }}>
                                            <noscript>
                                                <a href='https:&#47;&#47;unicef.sharepoint.com&#47;sites&#47;PD-Nutrition&#47;SitePages&#47;NutriDash.aspx?web=1'>
                                                <img alt=' ' src='https:&#47;&#47;public.tableau.com&#47;static&#47;images&#47;Ge&#47;GeneralInformation2016-2017FINALV5&#47;GeneralInformation&#47;1_rss.png' style={{ border: 'none' }} />
                                                </a>
                                            </noscript>
                                            <object className='tableauViz' style={{ display: 'none' }}>
                                                <param name='host_url' value='https%3A%2F%2Fpublic.tableau.com%2F' /> 
                                                <param name='embed_code_version' value='3' />
                                                <param name='site_root' value='' />
                                                <param name='name' value='GeneralInformation2016-2017FINALV5&#47;GeneralInformation' />
                                                <param name='tabs' value='no' /><param name='toolbar' value='no' />
                                                <param name='static_image' value='https:&#47;&#47;public.tableau.com&#47;static&#47;images&#47;Ge&#47;GeneralInformation2016-2017FINALV5&#47;GeneralInformation&#47;1.png' /> 
                                                <param name='animate_transition' value='yes' />
                                                <param name='display_static_image' value='yes' />
                                                <param name='display_spinner' value='yes' />
                                                <param name='display_overlay' value='yes' /><param name='display_count' value='yes' />
                                                <param name='filter' value='publish=yes' />
                                            </object></div>                
                                            <script type='text/javascript'>                  
                                              var divElement = document.getElementById('viz1558628813842');                   
                                              var vizElement = divElement.getElementsByTagName('object')[0];                   
                                              vizElement.style.width='900px';vizElement.style.height='900px';                    
                                              var scriptElement = document.createElement('script');                    
                                              scriptElement.src = 'https://public.tableau.com/javascripts/api/viz_v1.js';                    
                                              vizElement.parentNode.insertBefore(scriptElement, vizElement);                
                                            </script>
                                        </div>

                                    </>
                                    :
                                    <div className="invalidReport">
                                        No Report Found
                                </div>
                            }
                        </div>
                    </SurveyReportWrapper>

                </ApplicationMain>
            </>
        );
    }

}



// WEBPACK FOOTER //
// ./src/containers/SurveyReportsContainer.tsx